import React from 'react';
class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pager: {} };
  }
  UNSAFE_componentWillMount() {
    // set page if items array isn't empty
    if (this.props.items && this.props.items.length) {
      this.setPage(1);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    // reset page if items array has changed
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.currentPage);
    }
  }
  setPage(page) {
    var { items, total } = this.props;
    var pager = this.state.pager;
    if (page < 1 || (page > pager.totalPages && items.length === 0)) {
      return;
    }
    // get new pager object for specified page
    pager = this.getPager(total, page);
    // get new page of items from items array
    // var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
    // update state
    this.setState({ pager: pager });
    // call change page function in parent component
    this.props.onChangePage(page);
  }
  getPager(totalItems, currentPage) {
    // default to first page
    currentPage = currentPage || 1;
    // calculate total pages
    var totalPages = Math.ceil(totalItems / 10);
    var startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 7) {
        startPage = 1;
        endPage = 7;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 5;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 4;
      }
    }
    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * 10;
    var endIndex = Math.min(startIndex + 10 - 1, totalItems - 1);
    // create an array of pages to ng-repeat in the pager control
    var pages = [...Array(endPage + 1 - startPage).keys()].map(
      (i) => startPage + i,
    );
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  render() {
    var pager = this.state.pager;
    if (!pager.pages || pager.pages.length <= 1) {
      // don't display pager if there is only 1 page
      return null;
    }
    return (
      <ul className="pagination">
        <li
          className={`bg bg--light-white bg--actionbox d-flex align-items-center flex--content-center gutter gutter--mr-s  ${
            pager.currentPage === 1 ? 'disabled' : ''
          }`}
          onClick={() => (pager.currentPage === 1 ? null : this.setPage(1))}
        >
          <span>&#8249;&#8249;</span>
        </li>
        <li
          className={`bg bg--light-white bg--actionbox d-flex align-items-center flex--content-center gutter gutter--mr-s  ${
            pager.currentPage === 1 ? 'disabled' : ''
          }`}
          onClick={() =>
            pager.currentPage === 1 ? null : this.setPage(pager.currentPage - 1)
          }
        >
          <span>&#8249;</span>
        </li>
        {pager.pages.map((page, index) => {
          return (
            <li
              key={index}
              className={` bg--actionbox d-flex align-items-center flex--content-center gutter gutter--mr-s ${
                pager.currentPage === page ? 'active' : 'bg bg--light-white'
              }`}
              onClick={() => this.setPage(page)}
            >
              <span>{page}</span>
            </li>
          );
        })}
        <li
          className={`bg bg--light-white bg--actionbox d-flex align-items-center flex--content-center gutter gutter--mr-s ${
            pager.currentPage === pager.totalPages ? 'disabled' : ''
          }`}
          onClick={() =>
            pager.currentPage === pager.totalPages
              ? null
              : this.setPage(pager.currentPage + 1)
          }
        >
          <span>&#8250;</span>
        </li>
        <li
          className={`bg bg--light-white bg--actionbox d-flex align-items-center flex--content-center gutter gutter--mr-s ${
            pager.currentPage === pager.totalPages ? 'disabled' : ''
          }`}
          onClick={() =>
            pager.currentPage === pager.totalPages
              ? null
              : this.setPage(pager.totalPages)
          }
        >
          <span>&#8250;&#8250;</span>
        </li>
      </ul>
    );
  }
}
export default Pagination;
